import { get, post } from '@aiptyg/api-client';
import type {
  SupportFeedbackItemDTO,
  SupportFeedbackListResponseDTO,
  SupportFeedbackStatus,
} from '../types/support.types';

export function listSupportFeedbacks(params: {
  page: number;
  pageSize: number;
  userId: string;
  status: '' | SupportFeedbackStatus;
}): Promise<SupportFeedbackListResponseDTO> {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page));
  qs.set('page_size', String(params.pageSize));
  if (params.userId) {
    qs.set('user_id', params.userId);
  }
  if (params.status) {
    qs.set('status', params.status);
  }
  return get<SupportFeedbackListResponseDTO>(`/v1/admin/support/feedbacks?${qs.toString()}`);
}

export function getSupportFeedbackDetail(id: number): Promise<SupportFeedbackItemDTO> {
  return get<SupportFeedbackItemDTO>(`/v1/admin/support/feedbacks/${id}`);
}

export function updateSupportFeedbackStatus(
  id: number,
  status: SupportFeedbackStatus,
): Promise<SupportFeedbackItemDTO> {
  return post<SupportFeedbackItemDTO>(`/v1/admin/support/feedbacks/${id}/status`, { status });
}

export function reopenSupportFeedback(
  id: number,
  data: { content: string; image_data_urls: string[] },
): Promise<SupportFeedbackItemDTO> {
  return post<SupportFeedbackItemDTO>(`/v1/admin/support/feedbacks/${id}/reopen`, data);
}
